import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactSelect from 'react-select';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import firebase from 'config/config';
import swal from 'sweetalert';
import { CircularProgress, Typography } from '@material-ui/core';
import logger from '../../../utils/logger';
import apiCaller from '../../../utils/apiCallerOutstanding';
import getUtils from '../../../utils/getUtils';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
  },
  h5NoMargin: {
    marginTop: '2px !important',
    marginBottom: '2px !important',
  },
}));

const customStyles = {
  menu: provided => ({
    ...provided,
    zIndex: 999,
    position: 'absolute',
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  control: provided => ({
    ...provided,
    minHeight: '40px',
    width: '100%',
  }),
};

const buttonStyles = {
  background: '#3366FF',
  color: 'white',
  fontSize: '12px',
  textTransform: 'capitalize',
};
const editButtonStyles = {
  background: '#AFB2B7',
  color: 'black',
  fontSize: '12px',
  textTransform: 'capitalize',
};
const HomeLocation = ({ activeRole, selectedTruckerData, refetch }) => {
  const classes = useStyles();
  const [homeLocation, setHomeLocation] = React.useState(null);
  const [updating, setUpdating] = React.useState(false);
  const [isToBeEdited, setIsToBeEdited] = React.useState(
    selectedTruckerData?.home_location || ''
  );
  const [cities, setCities] = React.useState([]);

  const handleHomeLocationUpdate = async () => {
    setUpdating(true);
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const body = {
      trucker_id: selectedTruckerData?.trucker_id,
      home_location: homeLocation?.value || '',
    };
    const endPoint = `pipe/v1/home-location`;
    try {
      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');

      setTimeout(() => {
        swal('Success!', `Home Location updated successfully!`, 'success');
        refetch();
        setIsToBeEdited(true);
        setUpdating(false);
      }, 2000);
    } catch (error) {
      logger.error(error);
      swal(
        'Error!',
        `Failed to update Home Location, Please try again later!`,
        'error'
      );
      setUpdating(false);
    }
  };
  const getCities = async () => {
    const citiesData = await getUtils('cities');
    setCities(citiesData);
  };
  React.useEffect(() => {
    getCities();
  }, []);

  React.useEffect(() => {
    setHomeLocation(
      selectedTruckerData?.home_location
        ? {
            label: selectedTruckerData?.home_location,
            value: selectedTruckerData?.home_location,
          }
        : null
    );
  }, [selectedTruckerData?.home_location]);

  return (
    <div>
      <Typography
        variant="subtitle2"
        gutterBottom
        style={{ textTransform: 'capitalize', marginBottom: '10px' }}
      >
        Home Location
      </Typography>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={selectedTruckerData?.blacklist ? 12 : 8}>
          {isToBeEdited ? (
            <h5 className={classes.h5NoMargin}>{homeLocation?.label}</h5>
          ) : (
            <ReactSelect
              value={homeLocation}
              styles={customStyles}
              onChange={setHomeLocation}
              options={cities}
              placeholder="Select Home Location"
              isDisabled={isToBeEdited || selectedTruckerData?.blacklist}
            />
          )}
        </Grid>
        {!selectedTruckerData?.blacklist &&
          (isToBeEdited ? (
            <Grid item xs={4}>
              <Button
                size="small"
                variant="contained"
                style={editButtonStyles}
                onClick={() => {
                  setIsToBeEdited(false);
                }}
              >
                Edit
              </Button>
            </Grid>
          ) : (
            <Grid item xs={4}>
              {updating ? (
                <CircularProgress size={20} />
              ) : (
                <Button
                  size="small"
                  variant="contained"
                  style={buttonStyles}
                  onClick={handleHomeLocationUpdate}
                >
                  Submit
                </Button>
              )}
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

export default HomeLocation;
